import { usStates, type USState } from "@shared/schema";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface StateSelectorProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function StateSelector({ value, onChange, className }: StateSelectorProps) {
  const selectedState = usStates.find(s => s.code === value);

  return (
    <div className={`space-y-2 ${className}`}>
      <Label className="text-sm font-medium">State</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="select-state">
          <SelectValue>
            {selectedState ? selectedState.name : "Select a state"}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {usStates.map((state) => (
            <SelectItem 
              key={state.code} 
              value={state.code}
              data-testid={`option-state-${state.code}`}
            >
              <span className="flex items-center justify-between w-full gap-4">
                <span>{state.name}</span>
                <span className="text-muted-foreground text-sm">
                  {state.taxRate === 0 ? "No tax" : `${state.taxRate}%`}
                </span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
